// extracted by mini-css-extract-plugin
module.exports = {"container":"_1SpMCghOyvWw-aNwLvIHbA","groupsList":"jnBZ43iU3ZgjYAMjq_7mm"};